var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000732431 3.23887L0.721411 4L3.06745 1.52767L5.41349 4L6.13417 3.23887L3.06745 3.65702e-08L0.000732431 3.23887Z",
    fill: "#4ba497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDarkGreen);
export default __webpack_public_path__ + "static/media/chevron-up_dark-green.2c5695f9df9abee027efc55d4c3b4e25.svg";
export { ForwardRef as ReactComponent };